import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './BringBusinessForm.jsx'

export default createSubmit(name)